import * as React from "react";

import { Button, Grid, Table } from "semantic-ui-react";
import { Authorize } from "reauthorize";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { sraDepartmentsSelector } from "../selectors";
import { ADMIN_ROLES } from "../../../auth";

import { ApplicationState } from "../../../applicationState";

import { loadSraDepartments } from "../actions";

import { Link  } from "redux-little-router";

export const All: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const sraCustomerId = useSelector((state: ApplicationState) => state.router.params.sraCustomerId);
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const sraDepartments = useSelector(sraDepartmentsSelector);

    React.useEffect(() => {
        dispatch(loadSraDepartments({ sraCustomerId }));
    }, [dispatch, sraCustomerId]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Departments</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Authorize>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {sraDepartments && sraDepartments
                                .map(sraDepartment => (
                                    <Table.Row key={sraDepartment.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${sraDepartment.id}`}>
                                                {sraDepartment.name}
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
